/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  CardTransactionExpenseListSummaryRequest,
  CardTransactionExpenseListSummaryResponse,
  CardTransactionExpenseSearchRequest,
  ExpenseBulkUpdateDto,
  ExpenseExtDto,
  ExpenseIdsSearchResponse,
  PagedResponseExpenseExtDto,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class CardTransactionExpenseController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags card-transaction-expense-controller
   * @name SearchCardTransactionExpensesOld
   * @request POST:/api/v1/card-transaction-expenses
   * @deprecated
   */
  searchCardTransactionExpensesOld = (
    data: CardTransactionExpenseSearchRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<PagedResponseExpenseExtDto, any>({
      path: `/v1/card-transaction-expenses`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static searchCardTransactionExpensesOldPath = '/v1/card-transaction-expenses'
  static searchCardTransactionExpensesOldMethod = 'POST'
  /**
   * No description
   *
   * @tags card-transaction-expense-controller
   * @name GetSummary3
   * @request POST:/api/v1/card-transaction-expenses/summary
   */
  getSummary = (data: CardTransactionExpenseListSummaryRequest, params: RequestParams = {}) =>
    this.http.request<CardTransactionExpenseListSummaryResponse, any>({
      path: `/v1/card-transaction-expenses/summary`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static getSummaryPath = '/v1/card-transaction-expenses/summary'
  static getSummaryMethod = 'POST'
  /**
   * No description
   *
   * @tags card-transaction-expense-controller
   * @name SearchCardTransactionExpenses
   * @request POST:/api/v1/card-transaction-expenses/search
   */
  searchCardTransactionExpenses = (
    data: CardTransactionExpenseSearchRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<PagedResponseExpenseExtDto, any>({
      path: `/v1/card-transaction-expenses/search`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static searchCardTransactionExpensesPath = '/v1/card-transaction-expenses/search'
  static searchCardTransactionExpensesMethod = 'POST'
  /**
   * No description
   *
   * @tags card-transaction-expense-controller
   * @name SearchCardTransactionExpenseIds
   * @request POST:/api/v1/card-transaction-expenses/search-ids
   */
  searchCardTransactionExpenseIds = (
    data: CardTransactionExpenseSearchRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<ExpenseIdsSearchResponse, any>({
      path: `/v1/card-transaction-expenses/search-ids`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static searchCardTransactionExpenseIdsPath = '/v1/card-transaction-expenses/search-ids'
  static searchCardTransactionExpenseIdsMethod = 'POST'
  /**
   * No description
   *
   * @tags card-transaction-expense-controller
   * @name BulkUpdate1
   * @request POST:/api/v1/card-transaction-expenses/bulk-update
   */
  bulkUpdate = (data: ExpenseBulkUpdateDto, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/card-transaction-expenses/bulk-update`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static bulkUpdatePath = '/v1/card-transaction-expenses/bulk-update'
  static bulkUpdateMethod = 'POST'
  /**
   * No description
   *
   * @tags card-transaction-expense-controller
   * @name GetCardTransactionExpense
   * @request GET:/api/v1/card-transaction-expenses/{expenseId}
   */
  getCardTransactionExpense = (expenseId: string, params: RequestParams = {}) =>
    this.http.request<ExpenseExtDto, any>({
      path: `/v1/card-transaction-expenses/${expenseId}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getCardTransactionExpensePath = '/v1/card-transaction-expenses/${expenseId}'
  static getCardTransactionExpenseMethod = 'GET'
}
